import {SyncEventType} from '../../enums/syncEventType';
import {PersistenceEvent} from './persistenceEvent';

export class Eventuserloggedin implements PersistenceEvent {

  public readonly type = SyncEventType.USER_LOGGEDIN;
  public issueId: number;
  public avatar: string;

  constructor(issueId: number, avatar: string) {
    this.issueId = issueId;
    this.avatar = avatar;
  }

  getPayload(): object {
    return {
      'issueId': this.issueId,
      'avatar': this.avatar
    };
  }

  static fromPayload(payload: any): Eventuserloggedin {
    return new Eventuserloggedin(
      payload['issueId'],
      payload['avatar']
    );
  }

}

